import React, { useEffect, useState } from 'react';
import './ListingCardComponent.scss';
import {
  FaCompass,
  FaCouch,
  FaCalendarAlt,
  FaHeart,
  FaHourglassHalf,
  FaLayerGroup,
  FaRegHeart,
  FaRulerCombined,
} from 'react-icons/fa';
import { property } from '../../../utils/dummyData';
import { useDispatch, useSelector } from 'react-redux';
import { UnknownAction } from 'redux';
import {
  deleteFavProperty,
  postFavProperty,
  resetListingState,
  setIsFavourite,
} from '../../../redux/slices/ListingSlice';
import { toast } from 'react-toastify';
import { toastDefaults } from '../../../utils/ToastOptionCommon';
import { FaMapLocation } from 'react-icons/fa6';
import { redirect, useNavigate } from 'react-router';
import { AvailableDateFormat, USDateFormat } from '../../../utils/common';
import { Button, Carousel } from 'react-bootstrap';
import PropertySample from '../../../assets/images/PropertySample.jpg';
import VisitComponent from '../VisitComponent/VisitComponent';
import { VisitType } from '../../../constants/enums/VisitType';
import { dealTypeEnum, proprertyViewData } from '../../../constants/Property';
import { isUserAuthenticated } from '../../../redux/slices/LoginSlice';
import SignInPopupHOC from '../../../pages/Login/hoc/SigninHoc';

interface IProps {
  propertiesValues: property;
  signInToggleHandler: () => void;
  favedId: string;
  setFavedId: React.Dispatch<React.SetStateAction<string>>;
  isFeatureDisplay?: boolean;
  selectedView?: number;
}
function ListingCardComponent(props: IProps) {
  const [isLiked, setIsLiked] = useState<undefined | boolean>(
    props.propertiesValues.isFavourite ?? false
  );

  const address = props.propertiesValues.address;
  const rating = props.propertiesValues.averageRating;
  const buildingDetails =
    props.propertiesValues.buildingDetails ||
    props.propertiesValues.propertyDetails?.buildingDetails;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const isAuthenticated = useSelector(isUserAuthenticated);
  const [visit, setVisit] = useState({
    type: VisitType.Schedule,
    show: false,
    propertyId: '',
  });
  const visitInitialState = { name: '', phone: '' };

  const handleUnLike = (idToUnLike: any) => {
    if (isAuthenticated) {
      dispatch(
        deleteFavProperty({
          body: {
            user_id: JSON.parse(localStorage.getItem('user') ?? '')._id ?? '',
            propertie_id: props.propertiesValues._id,
          },
        }) as unknown as UnknownAction
      );
      props.setFavedId(idToUnLike);
    } else {
      props.signInToggleHandler();
    }
  };

  const handleLike = (idToLike: any) => {
    if (isAuthenticated) {
      dispatch(
        postFavProperty({
          body: {
            user_id: JSON.parse(localStorage.getItem('user') ?? '')._id ?? '',
            propertie_id: props.propertiesValues._id,
          },
        }) as unknown as UnknownAction
      );
      // dispatch(setIsFavourite({id:idToLike}));
      props.setFavedId(idToLike);
    } else {
      props.signInToggleHandler();
    }
  };

  const gotoDetail = (id: string, selectedRoomId: string, dealType: string) => {
    navigate(`/property-detail/${dealType || 'rent'}/${id}`, {
      state: { selectedRoomId, dealType },
    });
  };
  const visitShowHideHandler = () => {
    setVisit((state) => ({ ...state, show: !state.show }));
  };

  const withAuth =
    (action: (...args: any[]) => void) =>
    (...args: any[]) => {
      if (isAuthenticated) {
        action(...args);
      } else {
        props.signInToggleHandler();
      }
    };

  const handleShowCallback = withAuth(() => {
    setVisit({
      type: VisitType.Callback,
      show: true,
      propertyId: props.propertiesValues._id,
    });
  });

  return (
    <>
      {visit.show && (
        <VisitComponent
          initialState={visitInitialState}
          visitType={visit.type}
          show={visit.show}
          propertyId={visit.propertyId}
          visitShowHideHandler={visitShowHideHandler}
        />
      )}
      {/* <div className="row"> */}
      <div
        className={
          props.isFeatureDisplay
            ? 'px-2 h-100'
            : props.selectedView == 2
              ? 'col-md-4 mb-4'
              : 'col-md-4 mb-4'
        }
      >
        <div className="properties-card border-0 rounded-4 shadow-sm bg-white overflow-hidden transition-all hover-shadow-md position-relative">
          {/* Badges / Overlay Tags */}
          {(props.propertiesValues.isNew ||
            props.propertiesValues.isFeatured) && (
            <div className="position-absolute top-0 start-0 z-3 m-3 d-flex flex-column gap-1">
              {props.propertiesValues.isNew && (
                <span className="badge bg-success bg-opacity-90 backdrop-blur text-white px-2 py-1 rounded-2 fs-7 fw-semibold shadow-sm">
                  New
                </span>
              )}
              {props.propertiesValues.isFeatured && (
                <span className="badge bg-primary bg-opacity-90 backdrop-blur text-white px-2 py-1 rounded-2 fs-7 fw-semibold shadow-sm">
                  Featured
                </span>
              )}
            </div>
          )}

          {/* Wishlist Button */}
          <button
            type="button"
            className="btn btn-light rounded-circle position-absolute top-0 end-0 z-3 m-3 p-0 d-flex align-items-center justify-content-center shadow-sm"
            style={{ width: '36px', height: '36px' }}
            onClick={(e) => {
              e.stopPropagation();
              props.propertiesValues.isFavourite
                ? handleUnLike(props.propertiesValues._id)
                : handleLike(props.propertiesValues._id);
            }}
          >
            {props.propertiesValues.isFavourite ? (
              <FaHeart className="text-danger fs-6" />
            ) : (
              <FaRegHeart className="text-secondary fs-6" />
            )}
          </button>

          {/* Thumbnail Section */}
          <div
            className="properties-thumb position-relative overflow-hidden cursor-pointer"
            style={{ height: '220px' }}
          >
            {props.propertiesValues.fillImg?.length > 0 ? (
              <Carousel className="h-100 w-100">
                {props.propertiesValues.fillImg.map((image, i) => (
                  <Carousel.Item key={i} className="h-100">
                    <img
                      onClick={() =>
                        gotoDetail(
                          props.propertiesValues.propertyId,
                          props.propertiesValues._id,
                          props.propertiesValues.dealType
                        )
                      }
                      src={image}
                      alt={props.propertiesValues.title || 'Property thumbnail'}
                      className="w-100 h-100 object-fit-cover"
                    />
                  </Carousel.Item>
                ))}
              </Carousel>
            ) : (
              <img
                onClick={() =>
                  gotoDetail(
                    props.propertiesValues.propertyId,
                    props.propertiesValues._id,
                    props.propertiesValues.dealType
                  )
                }
                src={PropertySample}
                alt={
                  props.propertiesValues.title || 'Property sample thumbnail'
                }
                className="w-100 h-100 object-fit-cover"
              />
            )}

            {/* Bottom Badges on Image */}
            <div className="position-absolute bottom-0 start-0 end-0 p-3 d-flex justify-content-between align-items-end z-2 pointer-events-none bg-gradient-to-t">
              {props.propertiesValues.type && (
                <span className="badge bg-dark bg-opacity-75 backdrop-blur text-white px-3 py-1 rounded-pill text-capitalize fw-normal fs-7">
                  {proprertyViewData[props.propertiesValues.type] ||
                    props.propertiesValues.type}
                </span>
              )}

              {(props.propertiesValues.type === 'boys_pg' ||
                props.propertiesValues.type === 'girls_pg') &&
                props.propertiesValues.withFood === 'yes' && (
                  <span className="badge bg-warning text-dark px-3 py-2 rounded-pill fw-semibold fs-7 shadow-sm">
                    With Food
                  </span>
                )}
            </div>
          </div>

          {/* Card Content */}
          <div className="p-3 p-md-4 d-flex flex-column gap-3">
            {/* Title & Location */}
            <div>
              <h3
                className="properties-title fs-6 fw-bold text-dark text-truncate mb-1 cursor-pointer"
                title={props.propertiesValues.title}
                onClick={() =>
                  gotoDetail(
                    props.propertiesValues.propertyId,
                    props.propertiesValues._id,
                    props.propertiesValues.dealType
                  )
                }
              >
                {props.propertiesValues.title}
              </h3>
              <div className="d-flex align-items-center text-muted small gap-1">
                <FaMapLocation className="text-primary flex-shrink-0" />
                <span className="text-truncate">
                  {address?.city}
                  {address?.city && address?.state ? ', ' : ''}
                  {address?.state}
                </span>
              </div>
            </div>

            {/* Price & Rating Bar */}
            <div className="d-flex align-items-center justify-content-between pt-2 border-top border-light">
              <div>
                <span className="text-uppercase text-muted fs-7 fw-semibold d-block">
                  Price
                </span>
                <div className="d-flex align-items-baseline gap-1">
                  <span className="fs-5 fw-bold text-primary">
                    {props.propertiesValues.price?.toLocaleString('en-IN', {
                      style: 'currency',
                      currency: 'INR',
                      minimumFractionDigits: 0,
                    })}
                  </span>
                  {props.propertiesValues.dealType !== dealTypeEnum.Sell && (
                    <span className="text-muted small">/mo</span>
                  )}
                </div>
              </div>

              {rating !== null &&
                rating !== undefined &&
                !Number.isNaN(Number(rating)) && (
                  <div className="text-end">
                    <span className="text-uppercase text-muted fs-7 fw-semibold d-block">
                      Rating
                    </span>
                    <span
                      className={`badge rounded-pill px-2 py-1 fw-bold ${
                        Number(rating) >= 4.5
                          ? 'bg-success-subtle text-success'
                          : Number(rating) >= 3.5
                            ? 'bg-warning-subtle text-warning-emphasis'
                            : 'bg-danger-subtle text-danger'
                      }`}
                    >
                      ★ {Number(rating).toFixed(1)}
                    </span>
                  </div>
                )}

            </div>

            {(buildingDetails?.yearBuilt ||
              buildingDetails?.lastRenovatedYear) && (
              <div
                className="building-details-highlight"
                onClick={() =>
                  gotoDetail(
                    props.propertiesValues.propertyId,
                    props.propertiesValues._id,
                    props.propertiesValues.dealType
                  )
                }
              >
                <div className="building-details-heading">
                  <FaCalendarAlt />
                  <span>Building details</span>
                </div>
                <div className="building-details-values">
                  {buildingDetails.yearBuilt && (
                    <span className="building-detail-value">
                      <strong>Built</strong> {buildingDetails.yearBuilt}
                    </span>
                  )}
                  {buildingDetails.lastRenovatedYear && (
                    <span className="building-detail-value">
                      <strong>Renovated</strong>{' '}
                      {buildingDetails.lastRenovatedYear}
                    </span>
                  )}
                </div>
              </div>
            )}

            {/* Amenities / Key Specs Grid */}
            <div
              className="aminities-section pt-2 border-top border-light cursor-pointer"
              onClick={() =>
                gotoDetail(
                  props.propertiesValues.propertyId,
                  props.propertiesValues._id,
                  props.propertiesValues.dealType
                )
              }
            >
              <ul className="list-unstyled d-flex flex-wrap gap-2 m-0 p-0 fs-7 text-secondary">
                {props.propertiesValues.dealType !== dealTypeEnum.Sell &&
                  props.propertiesValues.features
                    ?.slice(0, 4)
                    ?.map((feature: any) => (
                      <li
                        key={feature._id}
                        className="d-flex align-items-center bg-light rounded-2 px-2 py-1 gap-1"
                      >
                        <div
                          dangerouslySetInnerHTML={{ __html: feature.icon }}
                          className="d-flex align-items-center"
                        />
                        <span>{feature.name}</span>
                      </li>
                    ))}

                {props.propertiesValues.dealType === dealTypeEnum.Sell && (
                  <>
                    {props.propertiesValues.propertyDetails
                      ?.furnishingStatus && (
                      <li className="d-flex align-items-center bg-light rounded-2 px-2 py-1 gap-1">
                        <FaCouch className="text-muted" />
                        <span>
                          {
                            props.propertiesValues.propertyDetails
                              .furnishingStatus
                          }
                        </span>
                      </li>
                    )}
                    {props.propertiesValues.propertyDetails?.carpetArea && (
                      <li className="d-flex align-items-center bg-light rounded-2 px-2 py-1 gap-1">
                        <FaRulerCombined className="text-muted" />
                        <span>
                          {props.propertiesValues.propertyDetails.carpetArea}{' '}
                          {
                            props.propertiesValues.propertyDetails
                              .carpetAreaUnit
                          }
                        </span>
                      </li>
                    )}
                    {props.propertiesValues.propertyDetails
                      ?.superBuiltUpArea && (
                      <li className="d-flex align-items-center bg-light rounded-2 px-2 py-1 gap-1">
                        <FaLayerGroup className="text-muted" />
                        <span>
                          {
                            props.propertiesValues.propertyDetails
                              .superBuiltUpArea
                          }{' '}
                          {
                            props.propertiesValues.propertyDetails
                              .superBuiltUpAreaUnit
                          }
                        </span>
                      </li>
                    )}
                    {props.propertiesValues.propertyDetails?.facing && (
                      <li className="d-flex align-items-center bg-light rounded-2 px-2 py-1 gap-1">
                        <FaCompass className="text-muted" />
                        <span>
                          {props.propertiesValues.propertyDetails.facing}
                        </span>
                      </li>
                    )}
                    {props.propertiesValues.propertyDetails?.propertyAge && (
                      <li className="d-flex align-items-center bg-light rounded-2 px-2 py-1 gap-1">
                        <FaHourglassHalf className="text-muted" />
                        <span>
                          {props.propertiesValues.propertyDetails.propertyAge}
                        </span>
                      </li>
                    )}
                  </>
                )}
              </ul>
            </div>

            {/* Action Button */}
            <Button
              className="btn btn-primary text-white fw-semibold rounded-3 py-2 text-uppercase w-100 shadow-sm mt-1"
              onClick={handleShowCallback}
            >
              Request A Callback
            </Button>
          </div>
        </div>
      </div>
      {/* </div> */}
    </>
  );
}

export default SignInPopupHOC(ListingCardComponent);
